import { mockCards } from '@/mocks/home';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">精选推荐</h2>
          <p className="text-sm text-foreground-600 max-w-[500px] mx-auto">
            编辑团队每日精选优质漫画，从热门韩漫到经典日漫，为你推荐不容错过的精彩作品
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-5">
          {mockCards.map((card, i) => (
            <div
              key={i}
              className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden transition-all duration-300 hover:border-primary-200 cursor-pointer"
            >
              <div className="relative w-full aspect-[4/3] overflow-hidden">
                <img
                  src={card.image}
                  alt={`虫虫漫画 - ${card.title}`}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-3 left-3">
                  <span className={`px-2 py-0.5 text-xs font-medium rounded-full ${card.tagColor}`}>
                    {card.tag}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-base font-heading text-foreground-900 mb-1">{card.title}</h3>
                <p className="text-xs text-foreground-500 mb-2">{card.subtitle}</p>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">{card.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}